import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    total: Number 
  }

  connect() {
    this.currentIndex = 0
    this.updateArrowStates()
    this.announceCurrent()
  }

  nextTicket() {
    if (this.currentIndex < this.totalValue - 1) this.showTicket(this.currentIndex + 1)
  }

  previousTicket() {
    if (this.currentIndex > 0) this.showTicket(this.currentIndex - 1)
  }

  showTicket(index) {
    // Hide current ticket
    const currentSlide = this.element.querySelector('.ticket-slide.active')
    if (currentSlide) currentSlide.classList.remove('active')

    // Show target ticket
    const targetSlide = this.element.querySelector(`[data-ticket-index="${index}"]`)
    if (targetSlide) targetSlide.classList.add('active')

    this.currentIndex = index
    this.updateArrowStates()
    this.announceCurrent()
  }

  // Let the self check-in button know which ticket is on screen so it can
  // target the right slug and hide when that ticket is already checked in.
  announceCurrent() {
    const slide = this.element.querySelector(".ticket-slide.active")
    if (!slide || !slide.dataset.slug) return
    this.element.dispatchEvent(new CustomEvent("ticket-carousel:changed", {
      bubbles: true,
      detail: { slug: slide.dataset.slug, checkedIn: slide.dataset.checkedIn === "true" },
    }))
  }

  updateArrowStates() {
    const leftArrow = this.element.querySelector('.left-arrow')
    const rightArrow = this.element.querySelector('.right-arrow')

    if (leftArrow) {
      if (this.currentIndex === 0) {
        leftArrow.classList.add('disabled')
        leftArrow.disabled = true
      } else {
        leftArrow.classList.remove('disabled')
        leftArrow.disabled = false
      }
    }

    if (rightArrow) {
      if (this.currentIndex === this.totalValue - 1) {
        rightArrow.classList.add('disabled')
        rightArrow.disabled = true
      } else {
        rightArrow.classList.remove('disabled')
        rightArrow.disabled = false
      }
    }
  }
}